import FieldControl from "../../../../../shared/ui/form/FieldControl";
import CheckboxField from "../../../../../shared/ui/field/CheckboxField";
import {FilterCheckboxFieldType, FilterFieldTypeEnum} from "../../../model/filter-types";
import {OnChangeFilterHandler} from "../../../model/useFilterHandler";
import {GLOBAL_STYLE_CONFIG} from "../../../../../app/styles/GlobalStyles";

interface IProps {
    keyField: string;
    field: FilterCheckboxFieldType;
    filedState: string[] | number[];
    onChangeHandler: OnChangeFilterHandler;
}

/**
 * Компонент для отображения чекбокса-фильтра.
 * Используется для бинарных фильтров (вкл/выкл), например: "Есть в наличии", "Новинка" и т.п.
 *
 * Проверка `isChecked` происходит по длине массива состояния — если есть выбранные значения, чекбокс активен.
 *
 * @param keyField - Ключ фильтра (идентификатор поля)
 * @param field - Конфигурация фильтра (заголовок, счётчик и т.д.)
 * @param filedState - Состояние фильтра (массив значений)
 * @param onChangeHandler - Обработчик изменения значения чекбокса
 *
 * @returns Элемент чекбокса, обёрнутый в FieldControl
 */
const FilterCheckbox = ({keyField, field, filedState, onChangeHandler}: IProps) => {
    const isChecked = Array.isArray(filedState) && filedState.length > 0;

    return (
        <FieldControl className={GLOBAL_STYLE_CONFIG.splitByPrefix('field-control')}>
            <CheckboxField
                checked={isChecked}
                onChange={(checked) => {
                    onChangeHandler(checked, keyField, FilterFieldTypeEnum.checkbox);
                }}
                label={`${field.title} (${field?.count})`}
                name={keyField}
            />
        </FieldControl>
    );
};

export default FilterCheckbox;